<div class="flex flex-wrap">
  <div class="w-full lg:w-8/12 px-4">
    <app-card-settings></app-card-settings>
  </div>
  <div class="w-full lg:w-4/12 px-4">
    <app-card-profile></app-card-profile>
  </div>
</div>
